import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, CalendarDays, Contact, FileText, Gift, IdCard, Megaphone, Presentation, Smartphone } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import { trackEvent } from '../../analytics';
import './Gallery.css';

const ITEM_META = [
  { icon: FileText, color: '#3157d5' }, { icon: IdCard, color: '#147d70' },
  { icon: Contact, color: '#97508a' }, { icon: CalendarDays, color: '#9b6b14' },
  { icon: Presentation, color: '#3972a9' }, { icon: Megaphone, color: '#9c506f' },
  { icon: BadgeCheck, color: '#417a58' }, { icon: Gift, color: '#a44c58' },
  { icon: Smartphone, color: '#644fa3' },
];

const Gallery: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const { language, content } = useI18n();
  const gallery = content.gallery;
  useEffect(() => setActiveFilter('all'), [language]);

  const visibleItems = activeFilter === 'all'
    ? gallery.items
    : gallery.items.filter(item => item.category === activeFilter);

  return (
    <section className="gallery section" aria-label={gallery.aria}>
      <div className="container">
        <div className="gallery__filters" aria-label={gallery.filterAria}>
          {gallery.filters.map(filter => (
            <button key={filter.id} className={`gallery__filter${activeFilter === filter.id ? ' active' : ''}`}
              onClick={() => {
                setActiveFilter(filter.id);
                trackEvent('select_content', {
                  content_type: 'gallery_filter',
                  item_id: filter.id,
                  language,
                });
              }} aria-pressed={activeFilter === filter.id}>
              {filter.label}
            </button>
          ))}
        </div>
        <div className="gallery__grid">
          {visibleItems.map(item => {
            const originalIndex = gallery.items.indexOf(item);
            const { icon: Icon, color } = ITEM_META[originalIndex];
            return (
              <article key={originalIndex} className="gallery__item" style={{ '--item-color': color } as React.CSSProperties}>
                <div className="gallery__preview"><Icon size={32} strokeWidth={1.35} /></div>
                <div className="gallery__item-body">
                  <span>{item.categoryLabel}</span><h2>{item.label}</h2>
                  <Link to="/request">{gallery.request}</Link>
                </div>
              </article>
            );
          })}
        </div>
        <p className="gallery__note">{gallery.note}</p>
      </div>
    </section>
  );
};

export default Gallery;
